export const UPDATE_MYPARKD_SETTING_START = 'UPDATE_APP_SETTING_START';

export const updateMyParkdSetting = (key: string, value: any, userId: number | string) => {
    return {
        type: UPDATE_MYPARKD_SETTING_START,
        payload: { key, value, userId }
    };
};
